import { render, staticRenderFns } from "./WorkflowFormBuilderPropertiesDrawer.vue?vue&type=template&id=ef0b8656&"
import script from "./WorkflowFormBuilderPropertiesDrawer.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderPropertiesDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports